import React from 'react';

import { SelectFieldOptionsType } from '@/types/schema';

import { ADD_OPTION_ID } from '../utils/getFilteredOptions';
import { AutocompleteRenderOptionState } from './OptionItem/types';
import AddOptionItem from './AddOptionItem';
import OptionItem from './OptionItem';

export const renderOption = (
  option: SelectFieldOptionsType,
  state: AutocompleteRenderOptionState,
) => {
  const Component = option.optionId === ADD_OPTION_ID ? AddOptionItem : OptionItem;
  return <Component option={option} state={state} />;
};
